exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-text-field--outlined > .v-input__control > .v-input__slot {\n  background-color: white !important;\n}\n", ""]);

// exports
